import { QueryClient } from '@tanstack/react-query'

/**
 * App-wide React Query client. Most data loading is RxDB-driven, so this only
 * backs the API-fetched surfaces (SCM identities, settings pages, etc.). Kept as
 * a single module-level instance so every route shares one cache. Individual
 * settings pages may still scope their own client for stricter freshness.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
})
